module.exports = __webpack_public_path__ + "img/Verpflegungsgruppe.56d64efe.svg";